import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from 'src/checkout/components/CheckoutDescription/CheckoutDescription';
import { BUY_TYPE, buyTypes } from 'src/checkout/templates/Checkout/Forms/CheckoutForm.types';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { Button } from 'src/general/components/Button/Button';
import { InputRadioFormik } from 'src/general/components/forms/Input/InputRadioFormik';
import { GreenRadio } from 'src/general/components/forms/Input/atoms/OptionFieldInput';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import { LoanTypeFormValidation, LoanTypeFormValues, PersonalizedQuoteFormProps } from './PersonalizedQuoteForm.type';

const initialValues: LoanTypeFormValues = {
  loanType: BUY_TYPE.PERSONAL,
};

export const LoanTypeForm: FC<PersonalizedQuoteFormProps<LoanTypeFormValues>> = ({
  values,
  onSubmit,
  onBack,
  isLoggedIn,
}) => (
  <>
    <CheckoutDescription title={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_LOAN_TYPE_FORM_HEADER)} onBack={onBack} />
    <Formik
      initialValues={{ ...initialValues, ...values }}
      onSubmit={onSubmit}
      validationSchema={LoanTypeFormValidation}
    >
      {(props) => (
        <Form className={styles.form}>
          <InputRadioFormik
            id="loanType"
            name="loanType"
            variant="group"
            inputIcon={GreenRadio}
            options={buyTypes.map((item) => ({
              value: item.value,
              label: <div className="multilines">{getMicrocopy(item.label, true)}</div>,
              'data-testid': `${item.value}-use`,
            }))}
          />
          <footer className={styles.footer}>
            <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
              {isLoggedIn
                ? getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_LOAN_TYPE_FORM_CTA_LOGGED_IN)
                : getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_LOAN_TYPE_FORM_CTA)}
            </Button>
          </footer>
        </Form>
      )}
    </Formik>
  </>
);
